import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "./App.css";

import WelcomeScreen from "./screens/WelcomeScreen";
import InstructionsScreen from "./screens/InstructionsScreen";
import ObjectiveScreen from "./screens/ObjectiveScreen";
import AssumptionsScreen from "./screens/AssumptionsScreen";
import CostsScreen from "./screens/CostsScreen";
import QuantitativeScreen from "./screens/QuantitativeScreen";
import QualitativeScreen from "./screens/QualitativeScreen";
import ReviewScreen from "./screens/ReviewScreen";
import SummaryScreen from "./screens/SummaryScreen";

const BrowserRouter = createBrowserRouter([
  {
    path: "/",
    element: <WelcomeScreen />,
  },
  {
    path: "/Welcome/",
    element: <WelcomeScreen />,
  },
  {
    path: "/Instructions/:uuid",
    element: <InstructionsScreen />,
  },
  {
    path: "/Objective/:uuid",
    element: <ObjectiveScreen />,
  },
  {
    path: "/Costs/:uuid",
    element: <CostsScreen />,
  },
  {
    path: "/Quantitative/:uuid",
    element: <QuantitativeScreen />,
  },

  {
    path: "/Qualitative/:uuid",
    element: <QualitativeScreen />,
  },
  {
    path: "/Assumptions/:uuid",
    element: <AssumptionsScreen />,
  },
  {
    path: "/Review/:uuid",
    element: <ReviewScreen />,
  },
  {
    path: "/Summary/:uuid",
    element: <SummaryScreen />,
  },
]);



function App() {
  return (
    <div>
      {/*<p>{process.env.REACT_APP_GRAPHQL_ENDPOINT}</p>
      {/* @ts-ignore */}
      <RouterProvider router={BrowserRouter}></RouterProvider>
    </div>
  );
}

export default App;
